import WaitlistBooking from 'components/HappeningNonContent/WaitlistBooking/WaitlistBooking';

export default WaitlistBooking;
